import * as React from 'react';
import { useLink, useLocation } from '@grandvisionhq/frk-routing';
import '@swc/helpers';
import 'lodash/isEmpty';
import '@grandvisionhq/utils';
import '../../mappers/errors-mapping.js';
import '../../utils/get-customer-details-payload.js';
import { appendQueryParamToUrl } from '../../utils/get-updated-url-with-query-params.js';
import '../../models/cart/cart-state.js';
import '../../models/checkout/checkout-step-error-type.js';
import '../../models/checkout-settings.js';
import '../../models/step-shipping/shipping-methods.js';
import '../../models/shared.js';
import 'history';
import '../../utils/has-cart-errors.js';

const useRedirectToOrderComplete = ()=>{
    const { href: orderConfirmHref  } = useLink({
        route: 'order.confirm',
        params: {
            orderData: ''
        }
    }) || {};
    const { replace  } = useLocation();
    /**
   * @description  redirect to /order/confirm page with query params
   * @argument param json of query parameter key & value
   */ const redirectToOrderComplete = React.useCallback((param = {})=>{
        if (orderConfirmHref) {
            replace(appendQueryParamToUrl(orderConfirmHref, param));
        } else {
            throw Error('Failed redirection to /order/confirm. Route not found');
        }
    }, [
        orderConfirmHref,
        replace
    ]);
    return redirectToOrderComplete;
};

export { useRedirectToOrderComplete };
//# sourceMappingURL=use-redirect-to-order-confirm-page.js.map
